import React, { PureComponent, Fragment, useState } from 'react';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import '@ant-design/compatible/assets/index.css';
import {
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  message,
  Modal,
  Tooltip,
  Form,
  Radio,
  Space,
  Divider,
} from 'antd';
import { connect } from 'dva';
import Label from '@/components/Label/Label';
import styles from './BasicGCPOverview.module.css';
import CoverageStatusConnections from '../CoverageStatusConnections';
import { COLOR } from '@/utils/color';
import { showDeleteConfirm } from '../showDeleteConfirm';
import DeleteCloudAccountWrapper from '../ConfigurationTab/Components/DeleteCloudAccountWrapper';
import OverviewInfoBar from '../ConfigurationTab/Components/OverviewInfoBar';

const AdvancedGCPOverview = props => {
  const { cloudAccountData, updateData } = props;

  return (
    <>
      <OverviewInfoBar cloudAccountData={cloudAccountData} />

      <Row>
        <Col span={12}>
          <CoverageStatusConnections
            cloudAccountData={cloudAccountData}
            isEditCloudAccount={true}
          />
        </Col>
      </Row>

      {/* <Divider /> */}

      {/* <DeleteCloudAccountWrapper
        handleDeleteAccount={props.handleDeleteAccount}
        handleDisbaledAccount={props.handleDisbaledAccount}
        showDisableAction={cloudAccountData.isActive}
        cloudAccountName={cloudAccountData.accountName}
        cloudAccountData={cloudAccountData}
      /> */}
    </>
  );
};

// export default BasicGCPOverview;
export default connect(({ cloudAccount }) => ({
  updating: cloudAccount.updating,
}))(AdvancedGCPOverview);
